
<template>
  <div>
    <!-- Pages without layout -->
    <div
      v-if="
        currentURL == '/homeEcommerce' ||
        currentURL == '/file_uploads' ||
        currentURL == '/get_location' ||
        isPublicPage
      "
    >
      <router-view />
    </div>

    <!-- Pages with Sidebar + Topbar -->
    <div v-else>
      <div v-if="resetpass != true" class="App">
        <div class="parent-conatiner">
          <Sidebar_page />
          <div class="main">
            <Topbar_page
              :NewLangData="allLanguageData"
              @update:language="language = $event"
            />
            <router-view />
          </div>
        </div>
      </div>

      <div v-else>
        <router-view />
      </div>
    </div>

    <ModalsContainer />
  </div>
</template>

<script setup>
import { ModalsContainer } from 'vue-final-modal'
</script>
<script>
  // import axios from 'axios';
  import { mapGetters, mapActions } from "vuex";
  import Sidebar_page from "./common/SideBar.vue";
  import Topbar_page from "./common/TopBar.vue";
  import axios from "axios";
  // import { nextTick } from "vue";
  export default {
    name: "App",
    data() {
      return {
        currentURL: this.$route.fullPath,
        resetpass: this.$route.meta.resetpassword,
        labelContent: {},
        language: "",
        filtersData: null,
        allLanguageData: null,
      };
    },
watch: {
  "$route"(to, from) {
    this.currentURL = to.fullPath;

    const publicRoutes = [
      "/",
      "/blogs",
      "/knowledgebase",
    ];

    const user =
      this.$store.getters.hasuserdetails ||
      JSON.parse(sessionStorage.getItem("user") || "null");

    if (!user && !publicRoutes.includes(to.path)) {
      this.$router.push({ name: "LandingPage" });
      return;
    }

    console.log(`URL changed from ${from.fullPath} to ${to.fullPath}`);
  },
},


    mounted() {
      window.addEventListener("resize", this.updateWidthOutput);
      this.updateWidthOutput();
    },
    beforeUnmount() {
  window.removeEventListener("resize", this.updateWidthOutput);
},
    created() {
      this.initializeData();

    },
    computed: {
      ...mapGetters(["routes"]),
isPublicPage() {
    const user =
      this.$store.getters.hasuserdetails ||
      JSON.parse(sessionStorage.getItem("user") || "null");

    return !user && [
      "/",
      "/blogs",
      "/knowledgebase",
    ].includes(this.$route.path);
  },
    },
    methods: {
     
      ...mapActions(["fetchRoutes"]),
      async initializeData() {
        try {
          await Promise.all([this.fetchRoutes(), this.GetAllLanguage()]);
        } catch (error) {
          console.error("Error during initialization", error);
        }
      },
      updateWidthOutput() {
        var windowWidth = window.innerWidth;
        if (windowWidth < 700) {
          let elements = document.getElementById("assidemenu");
          if (elements != null) {
            if (elements.classList.contains("aside") && document.getElementsByClassName("nameTopbar") && document.getElementsByClassName("parent-conatiner")) {
              document.getElementsByClassName("aside")[0].style.display = "none";
              document.getElementsByClassName("nameTopbar")[0].style.display = "block";
              document.getElementsByClassName("parent-conatiner")[0].style.gridTemplateColumns = "100%";
            }
          }
        }
      },

      async GetAllLanguage() {
        try {
          const res = await axios.get(`${process.env.VUE_APP_BASE_URL}lang/getalllanguage`);
          this.allLanguageData = res.data;
        } catch (error) {
          console.log(error);
        }
      },
      
    },

    components: {
      Sidebar_page,
      Topbar_page,
    },
  };
  document.addEventListener("DOMContentLoaded", function () {
    const menuItems = document.querySelectorAll(".menu-item");
    menuItems.forEach(function (menuItem) {
      menuItem.addEventListener("mouseover", function () {
        menuItems.forEach(function (item) {
          item.classList.remove("active");
        });
        menuItem.classList.add("active");
      });
    });
  });
</script>
<style>
  @import "./assets/projectscss/form.css";
  *{
    font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  }
  .editmodule {
    width: 60px;
    height: 30px;
    border: none;
    border-radius: 5px;
    background-color: #6b0a23;
    color: #fff;
  }

  .radio-container {
    margin-bottom: 10px;
    display: flex;
    align-items: center;
  }

  .radio-container label {
    margin-left: 5px;
  }
  .parent-conatiner {
    display: grid;
    grid-template-columns: 4% 96%;
    height: 100%;
  }

  .cursor-not-allow{
    cursor: not-allowed !important;
  }

  .border-not{
    border:none !important;
  }
  .for-save-form, .for-cancel-form{
    cursor:pointer;
  }
  .for-save-form, .for-cancel-form{
    font-weight: 600;
  }
  
  label.form_Label-Checkbox[for="isGlobal"] {
  color: #2563eb; /* blue */
  font-weight: 600;
}

.form_Label-css{
  width:fit-content;
}
  label.form_Label-Checkbox{
    font-size: 10px;
  }
  
  .pos-relative{
    position:relative;
  }
  .pos-absolute{
    position:absolute;
  }
</style>


